import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

class About extends React.Component {
    render(){
        return(
            <div className="m-3">
                <h1 className="H1">About Us</h1> 
                <div className="p-3">
                    <Breadcrumb tag="nav" listTag="div">
                        <BreadcrumbItem tag="a" href="/">Home</BreadcrumbItem>
                        <BreadcrumbItem active tag="span">About Us</BreadcrumbItem>
                    </Breadcrumb>
                </div>
                <p className="Font container">ThothIT LLC is an integrated IT solutions and services provider with its headquarter in Irving, 
                    Texas. We offer Software Development, Web Application development, Mobile Application Development, 
                    Ecommerce Solutions and enterprise planning solutions to various companies.<br></br> <br></br>

                    ThothIT is a highly process driven company. We believe in knowledge, skills and quality. Our combo of innovative designs, 
                    cutting-edge technologies, and end-user centric approach speaks for our excellence.</p>
            </div>
        )
    }
}

export default About;